export const HugoPanelTransitionMs = 260;
export const LauncherHeightPx = 48;
export const LauncherWidthPx = 48;
export const LauncherRightOffsetPx = 0;
export const LauncherTopPaddingPx = 80;
export const LauncherBottomPaddingPx = 24;
export const LauncherInitialTopPx = 320;
